import{_ as o}from"./_asciiWords.js";import{_ as r}from"./_hasUnicodeWord.js";import{t as s}from"./toString.js";import{_ as i}from"./_unicodeWords.js";var t=o,a=r,m=s,d=i;var n=function(o,r,s){return o=m(o),void 0===(r=s?void 0:r)?a(o)?d(o):t(o):o.match(r)||[]};export{n as w};
//# sourceMappingURL=words.js.map
